import React from 'react';
import { Table, Button, Input, Icon, Card, Dropdown, Menu, Modal, message, Popconfirm, Form, Upload } from 'antd';
import common from '../../assets/common.js';
import './index.css';

const FormItem = Form.Item;

const residences = [{
  value: 'zhejiang',
  label: 'Zhejiang',
  children: [{
    value: 'hangzhou',
    label: 'Hangzhou',
    children: [{
      value: 'xihu',
      label: 'West Lake',
    }],
  }],
}, {
  value: 'jiangsu',
  label: 'Jiangsu',
  children: [{
    value: 'nanjing',
    label: 'Nanjing',
    children: [{
      value: 'zhonghuamen',
      label: 'Zhong Hua Men',
    }],
  }],
}];
class Add extends React.Component {
  state = {
    confirmDirty: false,
    autoCompleteResult: [],
    record: ''
  };
  componentWillMount(){
    var that = this;
    if(sessionStorage.getItem('record')) {
      this.setState({
        record: JSON.parse(sessionStorage.getItem('record')),
        orgLogo: JSON.parse(sessionStorage.getItem('record')).orgLogo
      },() => {
        that.getDetail();
      })
      console.log(sessionStorage.getItem('record'));
    }
  }
  getDetail = () => {
    let postData = {};
    let _method = 'GET';
    postData["_url"] = 'api/organization/detail';
    postData["_method"] = _method;
    postData["id"] = this.state.record.id;// values.orgLogo.file.response.result;
    common.request(postData, this, function(obj, result){
      obj.setState({
        record: result.result
      })
    },function(obj, data){
      message.warning(data.message);
    });
  }
  handleSubmit = (e) => {
    let this_ = this;
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this_.submit(values);
      }
    });
  }
  submit = (values) => {
    let postData = values;
    let _method = 'POST';
    if(this.state.record) {
      _method = "PUT"
    }
    if(postData["appId"] != '') {
      postData["uface"] = {appId: postData["appId"],appKey: postData["appKey"], appSecret: postData["appSecret"]}
    }
    delete postData["appId"];
    delete postData["appKey"];
    delete postData["appSecret"];
    postData["_url"] = 'api/organization';
    postData["_method"] = _method;
    postData["orgLogo"] = this.state.orgLogo;// values.orgLogo.file.response.result;
    common.request(postData, this, function(obj, result){
      message.info("操作成功");
      window.location.href = "#/school";
    },function(obj, data){
      message.warning(data.message);
    });
  }
  //上传logo
  handleChange = (info) => {
    if (info.file.status === 'done') {
      getBase64(info.file.originFileObj);
      this.setState({
        orgLogo: info.fileList[info.fileList.length - 1].response.result,
      });
    }
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const record = this.state.record?this.state.record:'';
    const formItemLayout = {
      labelCol: {xs: { span: 24 },sm: { span: 6 },},
      wrapperCol: {xs: { span: 24 },sm: { span: 14 },},
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };
    let orgLogo = record?record.orgLogo: this.state.orgLogo;
    return (
      <Card>
        <Form onSubmit={this.handleSubmit} style={{maxWidth: 1020}}>
          <FormItem
            {...formItemLayout}
            label="学校简码"
          >
            {getFieldDecorator('orgId', {
              rules: [{
                required: true, message: '请输入学校简码，例如：shnu-ali!',
              }],
              initialValue: record?record.orgId:''
            })(
              <Input placeholder="请输入学校简码，例如：shnu-ali"/>
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="学校全称"
          >
            {getFieldDecorator('orgName', {
              rules: [{
                required: true, message: '请填写学校全称!',
              }],
              initialValue: record?record.orgName:''
            })(
              <Input type="text" placeholder="请输入学校全称"/>
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="学校Logo"
          >
            {getFieldDecorator('orgLogo', {
              rules: [{
                required: true, message: '请上传图片!',
              }],
              initialValue: record?record.orgLogo: ''
            })(
              <Upload
                className="avatar-uploader"
                name="file"
                showUploadList={false}
                action="api/upload/image"
                beforeUpload={beforeUpload}
                onChange={this.handleChange}
              >
                {orgLogo ?
                  <img src={orgLogo} alt="" className="avatar" /> :
                  <Icon type="plus" className="avatar-uploader-trigger" />
                }
              </Upload>
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="宇泛人脸AppId"
          >
            {getFieldDecorator('appId', {
              initialValue: record && record.uface?record.uface.appId:''
            })(
              <Input type="text" placeholder="请输入宇泛人脸appId"/>
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="宇泛人脸AppKey"
          >
            {getFieldDecorator('appKey', {
              initialValue: record && record.uface?record.uface.appKey:''
            })(
              <Input type="text" placeholder="请输入宇泛人脸appKey"/>
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="宇泛人脸AppSecret"
          >
            {getFieldDecorator('appSecret', {
              initialValue: record && record.uface?record.uface.appSecret:''
            })(
              <Input type="text" placeholder="请输入宇泛人脸AppSecret"/>
            )}
          </FormItem>
          {!record &&
            <FormItem
              {...formItemLayout}
              label="管理员账号"
            >
              {getFieldDecorator('userName', {
                rules: [{
                  required: true, message: '请填写管理员账号!',
                }],
              })(
                <Input type="text" placeholder="请输入管理员账号"/>
              )}
            </FormItem>
          }
          <FormItem {...tailFormItemLayout}>
            <Button type="primary" htmlType="submit">{record?'确认修改':'提交'}</Button>
          </FormItem>
        </Form>
      </Card>
    );
  }
}
const addFrom = Form.create()(Add);
export default addFrom;
function getBase64(img) {
    const reader = new FileReader();
    // reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
}

function beforeUpload(file) {
    const isJPGorPng = (file.type === 'image/jpeg' || file.type === 'image/png');
    if (!isJPGorPng) {
        message.error('仅支持 jpg 和 png 格式的图片！');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
        message.error('图片不能大于 2MB ！');
    }
    return isJPGorPng && isLt2M;
}



// WEBPACK FOOTER //
// ./src/component/school/add.js